import { render } from "./ManagePermission.vue?vue&type=template&id=f317d668&scoped=true"
import script from "./ManagePermission.vue?vue&type=script&lang=js"
export * from "./ManagePermission.vue?vue&type=script&lang=js"

import "./ManagePermission.vue?vue&type=style&index=0&id=f317d668&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f317d668"]])

export default __exports__